<div class="checkbox" [ngClass]="{ 'active' : active, 'small' : subtext }" (click)="getClicked()">
    <div class="top">
        <div class="box">
            <mat-icon svgIcon="check" *ngIf="active" [inline]="true"></mat-icon>
        </div>
        <div class="font-body2">{{text}}</div>
    </div>
    <div class="font-body2 subtext" *ngIf="subtext">{{subtext}}</div>
</div>